import { render, staticRenderFns } from "./Cafes.vue?vue&type=template&id=0b5421d0&"
import script from "./Cafes.vue?vue&type=script&lang=js&"
export * from "./Cafes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports